import { getCurrencySymbol } from '../../../../services/common.service';
import { InputErrorContainer } from '../../error/containers/input-error.container';
import { InputLabelContainer } from '../../label/containers/input-label.container';
import React from 'react';

export function NumberInputComponent({
  label,
  icon: Icon,
  placeholder,
  name,
  value,
  onValueChange,
  isDisabled,
  error,
  isErrored,
  type = 'number',
  step,
  min,
  max,
  adornmentPosition = 'end',
  noMargin,
  onClick,
  isRequired,
}: any) {
  const currencySymbol = getCurrencySymbol(label || name);

  return (
    <div
      className={`mb-3 ${noMargin ? '' : 'input-wrapper-overrider'}`}
      onClick={(event) => onClick && onClick(event)}
    >
      <InputLabelContainer
        isRequired={isRequired}
        label={label}
      />

      <div className="relative">
        {Icon && adornmentPosition === 'end' && (
          <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
            <Icon />
          </span>
        )}
        <div className="absolute inset-y-0 start-0 top-0 flex items-center ps-2.5 pointer-events-none">
          {currencySymbol && (
            <span className="w-4 h-4 border-r border-gray-300 font-medium text-gray-500 dark:text-gray-500" >
              {currencySymbol}

            </span>

          )}
        </div>
        <input
          className={`appearance-none block w-full bg-white border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500  ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''
            } ${Boolean(error) || isErrored ? 'border-red-500' : ''} ${(currencySymbol) ? 'ps-8' : ''}`}
          type={type}
          step={step}
          min={min}
          max={max}
          name={name}
          value={value}
          onChange={onValueChange}
          placeholder={placeholder}
          readOnly={isDisabled}
          onWheel={(e) => e.currentTarget.blur()}
        />
      </div>

      <InputErrorContainer error={error} />
    </div>
  );
}